/* AUTO-GENERATED FILE - DO NOT EDIT */

/* Components */
/* .blocks/v-shop-dynamic-home/vue-src/v-shop/components.js */
/* .blocks/v-shop-base-layout/vue-src/v-shop/components.js */
/* .blocks/v-shop/vue-src/v-shop/components.js */
/* .blocks/shop-payment-modo/vue-src/v-shop/components.js */
/* .blocks/cc-operator-mercadopago/vue-src/v-shop/components.js */
/* .blocks/cc-operator-decidir/vue-src/v-shop/components.js */
/* .blocks/shop-payment-credit-card/vue-src/v-shop/components.js */
/* .blocks/shop-payment-mobbex/vue-src/v-shop/components.js */
/* .blocks/shop-payment-gocuotas/vue-src/v-shop/components.js */
/* .blocks/shop-payment-cash/vue-src/v-shop/components.js */
/* .blocks/shop-payment-wiretransfer/vue-src/v-shop/components.js */
/* .blocks/shop-payment-mercadopago/vue-src/v-shop/components.js */

import Vue from 'vue'

const c = {}
const r = (a, b) => {
	c[a] = b
	Vue.component(a, b)
}
export const isComponent = (name) => name in c
export const getComponentsNames = () => Object.keys(c)

export const getComponents = () => ({ ...c })

r('Hook-ShopApp-SmartPopup', require('@/v-shop/smart-popup/comp_Hook-ShopApp-SmartPopup.vue').default)
r('Hook-ProductPage-InfoTabs', require('@/v-shop/product/comp_Hook-ProductPage-InfoTabs.vue').default)
r(
	'Hook-ProductPage-InfoDropdownImages',
	require('@/v-shop/product/comp_Hook-ProductPage-InfoDropdownImages.vue').default
)
r(
	'Hook-ProductPage-DescriptionAndAttrs',
	require('@/v-shop/product/comp_Hook-ProductPage-DescriptionAndAttrs.vue').default
)
r('Hook-ProductPage-DescInfoAndMedia', require('@/v-shop/product/comp_Hook-ProductPage-DescInfoAndMedia.vue').default)
r('Hook-ProductPage-BaseTemplate', require('@/v-shop/product/comp_Hook-ProductPage-BaseTemplate.vue').default)
r('AllReviewsDialog', () => import(/* webpackChunkName: "productpage" */ '@/v-shop/product/comp_AllReviewsDialog.vue'))
r('CollectionEventIcon', () =>
	import(/* webpackChunkName: "productpage" */ '@/v-shop/product/comp_CollectionEventIcon.vue')
)
r('ContentSwitcher', () => import(/* webpackChunkName: "productpage" */ '@/v-shop/product/comp_ContentSwitcher.vue'))
r('DiscountText', () => import(/* webpackChunkName: "productpage" */ '@/v-shop/product/comp_DiscountText.vue'))
r('Hover', () => import(/* webpackChunkName: "productpage" */ '@/v-shop/product/comp_Hover.vue'))
r('IconTextItem', () => import(/* webpackChunkName: "productpage" */ '@/v-shop/product/comp_IconTextItem.vue'))
r('ImageMagnifier', () => import(/* webpackChunkName: "productpage" */ '@/v-shop/product/comp_ImageMagnifier.vue'))
r('LimitedTimeOffer', () => import(/* webpackChunkName: "productpage" */ '@/v-shop/product/comp_LimitedTimeOffer.vue'))
r('LimitedTimeOfferCountdown', () =>
	import(/* webpackChunkName: "productpage" */ '@/v-shop/product/comp_LimitedTimeOfferCountdown.vue')
)
r('ListItemIcon', () => import(/* webpackChunkName: "productpage" */ '@/v-shop/product/comp_ListItemIcon.vue'))
r('PaymentOptions', () => import(/* webpackChunkName: "productpage" */ '@/v-shop/product/comp_PaymentOptions.vue'))
r('PriceLayout', () => import(/* webpackChunkName: "productpage" */ '@/v-shop/product/comp_PriceLayout.vue'))
r('ProductActions', () => import(/* webpackChunkName: "productpage" */ '@/v-shop/product/comp_ProductActions.vue'))
r('ProductActionsSmall', () =>
	import(/* webpackChunkName: "productpage" */ '@/v-shop/product/comp_ProductActionsSmall.vue')
)
r('ProductDiscount', () => import(/* webpackChunkName: "productpage" */ '@/v-shop/product/comp_ProductDiscount.vue'))
r('ProductImagesCarousel', () =>
	import(/* webpackChunkName: "productpage" */ '@/v-shop/product/comp_ProductImagesCarousel.vue')
)
r('ProductImagesDialog', () =>
	import(/* webpackChunkName: "productpage" */ '@/v-shop/product/comp_ProductImagesDialog.vue')
)
r('ProductImagesGrid', () =>
	import(/* webpackChunkName: "productpage" */ '@/v-shop/product/comp_ProductImagesGrid.vue')
)
r('ProductImagesVertical', () =>
	import(/* webpackChunkName: "productpage" */ '@/v-shop/product/comp_ProductImagesVertical.vue')
)
r('ProductInfoDescription', () =>
	import(/* webpackChunkName: "productpage" */ '@/v-shop/product/comp_ProductInfoDescription.vue')
)
r('ProductPage-AdditionalPaymentInfo', () =>
	import(/* webpackChunkName: "productpage" */ '@/v-shop/product/comp_ProductPage-AdditionalPaymentInfo.vue')
)
r('ProductPage-Attributes', () =>
	import(/* webpackChunkName: "productpage" */ '@/v-shop/product/comp_ProductPage-Attributes.vue')
)
r('ProductPage-BrandSkuEanSeller', () =>
	import(/* webpackChunkName: "productpage" */ '@/v-shop/product/comp_ProductPage-BrandSkuEanSeller.vue')
)
r('ProductPage-DeliveryCalc-Results', () =>
	import(/* webpackChunkName: "productpage" */ '@/v-shop/product/comp_ProductPage-DeliveryCalc-Results.vue')
)
r('ProductPage-DeliveryCalc', () =>
	import(/* webpackChunkName: "productpage" */ '@/v-shop/product/comp_ProductPage-DeliveryCalc.vue')
)
r('ProductPage-Description', () =>
	import(/* webpackChunkName: "productpage" */ '@/v-shop/product/comp_ProductPage-Description.vue')
)
r('ProductPage-InfoDropdownImages', () =>
	import(/* webpackChunkName: "productpage" */ '@/v-shop/product/comp_ProductPage-InfoDropdownImages.vue')
)
r('ProductPage-InfoTabs', () =>
	import(/* webpackChunkName: "productpage" */ '@/v-shop/product/comp_ProductPage-InfoTabs.vue')
)
r('ProductPage-LimitedTimeOffer', () =>
	import(/* webpackChunkName: "productpage" */ '@/v-shop/product/comp_ProductPage-LimitedTimeOffer.vue')
)
r('ProductPage-MainContainer', () =>
	import(/* webpackChunkName: "productpage" */ '@/v-shop/product/comp_ProductPage-MainContainer.vue')
)
r('ProductPage-PaymentsModal', () =>
	import(/* webpackChunkName: "productpage" */ '@/v-shop/product/comp_ProductPage-PaymentsModal.vue')
)
r('ProductPage-Promos', () =>
	import(/* webpackChunkName: "productpage" */ '@/v-shop/product/comp_ProductPage-Promos.vue')
)
r('ProductPage-Reviews', () =>
	import(/* webpackChunkName: "productpage" */ '@/v-shop/product/comp_ProductPage-Reviews.vue')
)
r('ProductPage-Tags', () => import(/* webpackChunkName: "productpage" */ '@/v-shop/product/comp_ProductPage-Tags.vue'))
r('ProductReviews', () => import(/* webpackChunkName: "productpage" */ '@/v-shop/product/comp_ProductReviews.vue'))
r('ProductShareBtn', () => import(/* webpackChunkName: "productpage" */ '@/v-shop/product/comp_ProductShareBtn.vue'))
r('ProductSheetDefault', () =>
	import(/* webpackChunkName: "productpage" */ '@/v-shop/product/comp_ProductSheetDefault.vue')
)
r('ProductSheetThreeColumns', () =>
	import(/* webpackChunkName: "productpage" */ '@/v-shop/product/comp_ProductSheetThreeColumns.vue')
)
r('ProductStockAvailabilityMessage', () =>
	import(/* webpackChunkName: "productpage" */ '@/v-shop/product/comp_ProductStockAvailabilityMessage.vue')
)
r('ProductStockQtyMessage', () =>
	import(/* webpackChunkName: "productpage" */ '@/v-shop/product/comp_ProductStockQtyMessage.vue')
)
r('ShareProduct', () => import(/* webpackChunkName: "productpage" */ '@/v-shop/product/comp_ShareProduct.vue'))
r('StockReminderForm', () =>
	import(/* webpackChunkName: "productpage" */ '@/v-shop/product/comp_StockReminderForm.vue')
)
r('VariantSelector-SelectItem', () =>
	import(/* webpackChunkName: "productpage" */ '@/v-shop/product/comp_VariantSelector-SelectItem.vue')
)
r('VariantsSelector', () => import(/* webpackChunkName: "productpage" */ '@/v-shop/product/comp_VariantsSelector.vue'))
r('Footer-Bottom', () => import(/* webpackChunkName: "footer" */ '@/v-shop/footer/comp_Footer-Bottom.vue'))
r('Footer-BrandsList', () => import(/* webpackChunkName: "footer" */ '@/v-shop/footer/comp_Footer-BrandsList.vue'))
r('Footer-BusinessInfo', () => import(/* webpackChunkName: "footer" */ '@/v-shop/footer/comp_Footer-BusinessInfo.vue'))
r('Footer-CategoriesList', () =>
	import(/* webpackChunkName: "footer" */ '@/v-shop/footer/comp_Footer-CategoriesList.vue')
)
r('Footer-Certificates', () => import(/* webpackChunkName: "footer" */ '@/v-shop/footer/comp_Footer-Certificates.vue'))
r('Footer-LinkList', () => import(/* webpackChunkName: "footer" */ '@/v-shop/footer/comp_Footer-LinkList.vue'))
r('Footer-Newsletter', () => import(/* webpackChunkName: "footer" */ '@/v-shop/footer/comp_Footer-Newsletter.vue'))
r('Footer-Top', () => import(/* webpackChunkName: "footer" */ '@/v-shop/footer/comp_Footer-Top.vue'))
r('Footer', () => import(/* webpackChunkName: "footer" */ '@/v-shop/footer/comp_Footer.vue'))
r('FooterContactList', () => import(/* webpackChunkName: "footer" */ '@/v-shop/footer/comp_FooterContactList.vue'))
r('FooterLinkItem', () => import(/* webpackChunkName: "footer" */ '@/v-shop/footer/comp_FooterLinkItem.vue'))
r('FooterLinkList', () => import(/* webpackChunkName: "footer" */ '@/v-shop/footer/comp_FooterLinkList.vue'))
r('FooterSocialItem', () => import(/* webpackChunkName: "footer" */ '@/v-shop/footer/comp_FooterSocialItem.vue'))
r('FooterSocialsList', () => import(/* webpackChunkName: "footer" */ '@/v-shop/footer/comp_FooterSocialsList.vue'))
r('ActionBarMobile', () => import(/* webpackChunkName: "appbar" */ '@/v-shop/appbar/comp_ActionBarMobile.vue'))
r('AppBar-Bottom-CategoriesMenu', () =>
	import(/* webpackChunkName: "appbar" */ '@/v-shop/appbar/comp_AppBar-Bottom-CategoriesMenu.vue')
)
r('AppBar-Bottom-MenuItems', () =>
	import(/* webpackChunkName: "appbar" */ '@/v-shop/appbar/comp_AppBar-Bottom-MenuItems.vue')
)
r('AppBar-Bottom', () => import(/* webpackChunkName: "appbar" */ '@/v-shop/appbar/comp_AppBar-Bottom.vue'))
r('AppBar-Buttons', () => import(/* webpackChunkName: "appbar" */ '@/v-shop/appbar/comp_AppBar-Buttons.vue'))
r('AppBar-Top', () => import(/* webpackChunkName: "appbar" */ '@/v-shop/appbar/comp_AppBar-Top.vue'))
r('AppBar-TopMsg-Item', () => import(/* webpackChunkName: "appbar" */ '@/v-shop/appbar/comp_AppBar-TopMsg-Item.vue'))
r('AppBar-TopMsg', () => import(/* webpackChunkName: "appbar" */ '@/v-shop/appbar/comp_AppBar-TopMsg.vue'))
r('AppBar', () => import(/* webpackChunkName: "appbar" */ '@/v-shop/appbar/comp_AppBar.vue'))
r('AppBarMobileSearch', () => import(/* webpackChunkName: "appbar" */ '@/v-shop/appbar/comp_AppBarMobileSearch.vue'))
r('AppBarRound-Drawer', () => import(/* webpackChunkName: "appbar" */ '@/v-shop/appbar/comp_AppBarRound-Drawer.vue'))
r('AppBarRound', () => import(/* webpackChunkName: "appbar" */ '@/v-shop/appbar/comp_AppBarRound.vue'))
r('AppBarTransparent', () => import(/* webpackChunkName: "appbar" */ '@/v-shop/appbar/comp_AppBarTransparent.vue'))
r('AutocompleteSearchField-ProductItem', () =>
	import(/* webpackChunkName: "appbar" */ '@/v-shop/appbar/comp_AutocompleteSearchField-ProductItem.vue')
)
r('AutocompleteSearchField', () =>
	import(/* webpackChunkName: "appbar" */ '@/v-shop/appbar/comp_AutocompleteSearchField.vue')
)
r('BrandsDialog', () => import(/* webpackChunkName: "appbar" */ '@/v-shop/appbar/comp_BrandsDialog.vue'))
r('CategoriesMegaMenu-CategoriesList', () =>
	import(/* webpackChunkName: "appbar" */ '@/v-shop/appbar/comp_CategoriesMegaMenu-CategoriesList.vue')
)
r('CategoriesMegaMenu-CategoryTitle', () =>
	import(/* webpackChunkName: "appbar" */ '@/v-shop/appbar/comp_CategoriesMegaMenu-CategoryTitle.vue')
)
r('CategoriesMegaMenu-Image', () =>
	import(/* webpackChunkName: "appbar" */ '@/v-shop/appbar/comp_CategoriesMegaMenu-Image.vue')
)
r('CategoriesMegaMenu-Overlay', () =>
	import(/* webpackChunkName: "appbar" */ '@/v-shop/appbar/comp_CategoriesMegaMenu-Overlay.vue')
)
r('CategoriesMegaMenu', () => import(/* webpackChunkName: "appbar" */ '@/v-shop/appbar/comp_CategoriesMegaMenu.vue'))
r('CategoriesMegaMenuHorizontal', () =>
	import(/* webpackChunkName: "appbar" */ '@/v-shop/appbar/comp_CategoriesMegaMenuHorizontal.vue')
)
r('CustomIcon', () => import(/* webpackChunkName: "appbar" */ '@/v-shop/appbar/comp_CustomIcon.vue'))
r('MobileMenuDrawer-Categories', () =>
	import(/* webpackChunkName: "appbar" */ '@/v-shop/appbar/comp_MobileMenuDrawer-Categories.vue')
)
r('MobileMenuDrawer-CustomizableLinks', () =>
	import(/* webpackChunkName: "appbar" */ '@/v-shop/appbar/comp_MobileMenuDrawer-CustomizableLinks.vue')
)
r('MobileMenuDrawer-MegaMenuCategories', () =>
	import(/* webpackChunkName: "appbar" */ '@/v-shop/appbar/comp_MobileMenuDrawer-MegaMenuCategories.vue')
)
r('MobileMenuDrawer', () => import(/* webpackChunkName: "appbar" */ '@/v-shop/appbar/comp_MobileMenuDrawer.vue'))
r('AppRouteLoadingBar', require('@/v-shop/app/comp_AppRouteLoadingBar.vue').default)
r('ShopApp', require('@/v-shop/app/comp_ShopApp.vue').default)
r('UserCustomFieldsPopup', require('@/v-shop/app/comp_UserCustomFieldsPopup.vue').default)
r('AppMessageDialog', require('@/v-shop/common/comp_AppMessageDialog.vue').default)
r('Breadcrumbs', require('@/v-shop/common/comp_Breadcrumbs.vue').default)
r('CardLayout', require('@/v-shop/common/comp_CardLayout.vue').default)
r('Carousel', require('@/v-shop/common/comp_Carousel.vue').default)
r('CartAutoRemovalsChip', require('@/v-shop/common/comp_CartAutoRemovalsChip.vue').default)
r('CartAutoRemovalsModal', require('@/v-shop/common/comp_CartAutoRemovalsModal.vue').default)
r('ClientSideOnly', require('@/v-shop/common/comp_ClientSideOnly.vue').default)
r('Container', require('@/v-shop/common/comp_Container.vue').default)
r('CookiesDisclaimer', require('@/v-shop/common/comp_CookiesDisclaimer.vue').default)
r('CountryPhoneCodeSelector', require('@/v-shop/common/comp_CountryPhoneCodeSelector.vue').default)
r('DpcHook', require('@/v-shop/common/comp_DpcHook.vue').default)
r('HtmlOrSlot', require('@/v-shop/common/comp_HtmlOrSlot.vue').default)
r('LoadingBar', require('@/v-shop/common/comp_LoadingBar.vue').default)
r('OrderTotalGoalProgress', require('@/v-shop/common/comp_OrderTotalGoalProgress.vue').default)
r('PriceText', require('@/v-shop/common/comp_PriceText.vue').default)
r('ProductCardPrice', require('@/v-shop/common/comp_ProductCardPrice.vue').default)
r('ProductCardRating', require('@/v-shop/common/comp_ProductCardRating.vue').default)
r('ProductDataSheet', require('@/v-shop/common/comp_ProductDataSheet.vue').default)
r('ProductPrevPrice', require('@/v-shop/common/comp_ProductPrevPrice.vue').default)
r('ProductPrice', require('@/v-shop/common/comp_ProductPrice.vue').default)
r('ProductsCarousel', require('@/v-shop/common/comp_ProductsCarousel.vue').default)
r('ProductsCarouselForFeaturedCard', require('@/v-shop/common/comp_ProductsCarouselForFeaturedCard.vue').default)
r('ProductsLayout', require('@/v-shop/common/comp_ProductsLayout.vue').default)
r('ProductWishlistToggler', require('@/v-shop/common/comp_ProductWishlistToggler.vue').default)
r('QtyInput', require('@/v-shop/common/comp_QtyInput.vue').default)
r('SkuChip', require('@/v-shop/common/comp_SkuChip.vue').default)
r('Title', require('@/v-shop/common/comp_Title.vue').default)
r('WhatsappBtn', require('@/v-shop/common/comp_WhatsappBtn.vue').default)
r('WhatsappChat', require('@/v-shop/common/comp_WhatsappChat.vue').default)
r('Media', require('@/media/comp_Media.vue').default)
r('RatioBox', require('@/media/comp_RatioBox.vue').default)
r('RatioIframe', require('@/media/comp_RatioIframe.vue').default)
r('RatioImage', require('@/media/comp_RatioImage.vue').default)
r('RatioPdf', require('@/media/comp_RatioPdf.vue').default)
r('RatioVideo', require('@/media/comp_RatioVideo.vue').default)
r('Button', require('@/vuetify-common/comp_Button.vue').default)
r('SafeLink', require('@/vuetify-common/comp_SafeLink.vue').default)
r('TextField', require('@/vuetify-common/comp_TextField.vue').default)
r('Validator', require('@/vuetify-common/comp_Validator.vue').default)
r('ProductCard-Actions', () =>
	import(/* webpackChunkName: "productcard" */ '@/v-shop/product-card/comp_ProductCard-Actions.vue')
)
r('ProductCard-AttrsTags', () =>
	import(/* webpackChunkName: "productcard" */ '@/v-shop/product-card/comp_ProductCard-AttrsTags.vue')
)
r('ProductCard-Design1', () =>
	import(/* webpackChunkName: "productcard" */ '@/v-shop/product-card/comp_ProductCard-Design1.vue')
)
r('ProductCard-Design1Featured', () =>
	import(/* webpackChunkName: "productcard" */ '@/v-shop/product-card/comp_ProductCard-Design1Featured.vue')
)
r('ProductCard-Design1Small', () =>
	import(/* webpackChunkName: "productcard" */ '@/v-shop/product-card/comp_ProductCard-Design1Small.vue')
)
r('ProductCard-Design2', () =>
	import(/* webpackChunkName: "productcard" */ '@/v-shop/product-card/comp_ProductCard-Design2.vue')
)
r('ProductCard-Design2Featured', () =>
	import(/* webpackChunkName: "productcard" */ '@/v-shop/product-card/comp_ProductCard-Design2Featured.vue')
)
r('ProductCard-Design2Small', () =>
	import(/* webpackChunkName: "productcard" */ '@/v-shop/product-card/comp_ProductCard-Design2Small.vue')
)
r('ProductCard-Design3', () =>
	import(/* webpackChunkName: "productcard" */ '@/v-shop/product-card/comp_ProductCard-Design3.vue')
)
r('ProductCard-Design3Featured', () =>
	import(/* webpackChunkName: "productcard" */ '@/v-shop/product-card/comp_ProductCard-Design3Featured.vue')
)
r('ProductCard-Design3Small', () =>
	import(/* webpackChunkName: "productcard" */ '@/v-shop/product-card/comp_ProductCard-Design3Small.vue')
)
r('ProductCard-Design4', () =>
	import(/* webpackChunkName: "productcard" */ '@/v-shop/product-card/comp_ProductCard-Design4.vue')
)
r('ProductCard-Design4Featured', () =>
	import(/* webpackChunkName: "productcard" */ '@/v-shop/product-card/comp_ProductCard-Design4Featured.vue')
)
r('ProductCard-Design4Small', () =>
	import(/* webpackChunkName: "productcard" */ '@/v-shop/product-card/comp_ProductCard-Design4Small.vue')
)
r('ProductCard-Design5', () =>
	import(/* webpackChunkName: "productcard" */ '@/v-shop/product-card/comp_ProductCard-Design5.vue')
)
r('ProductCard-Design5Featured', () =>
	import(/* webpackChunkName: "productcard" */ '@/v-shop/product-card/comp_ProductCard-Design5Featured.vue')
)
r('ProductCard-Design5Small', () =>
	import(/* webpackChunkName: "productcard" */ '@/v-shop/product-card/comp_ProductCard-Design5Small.vue')
)
r('ProductCard-Design6', () =>
	import(/* webpackChunkName: "productcard" */ '@/v-shop/product-card/comp_ProductCard-Design6.vue')
)
r('ProductCard-Design6Featured', () =>
	import(/* webpackChunkName: "productcard" */ '@/v-shop/product-card/comp_ProductCard-Design6Featured.vue')
)
r('ProductCard-Design6Small', () =>
	import(/* webpackChunkName: "productcard" */ '@/v-shop/product-card/comp_ProductCard-Design6Small.vue')
)
r('ProductCard-Design7', () =>
	import(/* webpackChunkName: "productcard" */ '@/v-shop/product-card/comp_ProductCard-Design7.vue')
)
r('ProductCard-Design7Featured', () =>
	import(/* webpackChunkName: "productcard" */ '@/v-shop/product-card/comp_ProductCard-Design7Featured.vue')
)
r('ProductCard-Design7Small', () =>
	import(/* webpackChunkName: "productcard" */ '@/v-shop/product-card/comp_ProductCard-Design7Small.vue')
)
r('ProductCard-Design8', () =>
	import(/* webpackChunkName: "productcard" */ '@/v-shop/product-card/comp_ProductCard-Design8.vue')
)
r('ProductCard-Design8Featured', () =>
	import(/* webpackChunkName: "productcard" */ '@/v-shop/product-card/comp_ProductCard-Design8Featured.vue')
)
r('ProductCard-Design8Small', () =>
	import(/* webpackChunkName: "productcard" */ '@/v-shop/product-card/comp_ProductCard-Design8Small.vue')
)
r('ProductCard-FinancingTag', () =>
	import(/* webpackChunkName: "productcard" */ '@/v-shop/product-card/comp_ProductCard-FinancingTag.vue')
)
r('ProductCard-ForSmallCarousel', () =>
	import(/* webpackChunkName: "productcard" */ '@/v-shop/product-card/comp_ProductCard-ForSmallCarousel.vue')
)
r('ProductCard-Sq', () => import(/* webpackChunkName: "productcard" */ '@/v-shop/product-card/comp_ProductCard-Sq.vue'))
r('ProductCard-Tags', () =>
	import(/* webpackChunkName: "productcard" */ '@/v-shop/product-card/comp_ProductCard-Tags.vue')
)
r('ProductCard-TextTag', () =>
	import(/* webpackChunkName: "productcard" */ '@/v-shop/product-card/comp_ProductCard-TextTag.vue')
)
r('ProductCard-VariantSelector', () =>
	import(/* webpackChunkName: "productcard" */ '@/v-shop/product-card/comp_ProductCard-VariantSelector.vue')
)
r('ProductCard', () => import(/* webpackChunkName: "productcard" */ '@/v-shop/product-card/comp_ProductCard.vue'))
r('unused_comp_Hook-ProductCard-Attrs.vue', () =>
	import(/* webpackChunkName: "productcard" */ '@/v-shop/product-card/unused_comp_Hook-ProductCard-Attrs.vue')
)
r('CartDrawer', () => import(/* webpackChunkName: "cartdrawer" */ '@/v-shop/cart-drawer/comp_CartDrawer.vue'))
r('CartItem', () => import(/* webpackChunkName: "cartdrawer" */ '@/v-shop/cart-drawer/comp_CartItem.vue'))
r('CartItemChildren', () =>
	import(/* webpackChunkName: "cartdrawer" */ '@/v-shop/cart-drawer/comp_CartItemChildren.vue')
)
r('ForgotForm', () => import(/* webpackChunkName: "login" */ '@/v-shop/login/comp_ForgotForm.vue'))
r('GoogleAuthButton', () => import(/* webpackChunkName: "login" */ '@/v-shop/login/comp_GoogleAuthButton.vue'))
r('LoginDrawer', () => import(/* webpackChunkName: "login" */ '@/v-shop/login/comp_LoginDrawer.vue'))
r('LoginForm', () => import(/* webpackChunkName: "login" */ '@/v-shop/login/comp_LoginForm.vue'))
r('LoginForms', () => import(/* webpackChunkName: "login" */ '@/v-shop/login/comp_LoginForms.vue'))
r('SignupForm', () => import(/* webpackChunkName: "login" */ '@/v-shop/login/comp_SignupForm.vue'))
r('ThirdPartyLoginsButtons', () =>
	import(/* webpackChunkName: "login" */ '@/v-shop/login/comp_ThirdPartyLoginsButtons.vue')
)
r('BannerItem', () => import(/* webpackChunkName: "dpc" */ '@/v-shop/dynamic-pages-components/comp_BannerItem.vue'))
r('dpc-4BannersPlusSlide', () =>
	import(/* webpackChunkName: "dpc" */ '@/v-shop/dynamic-pages-components/comp_dpc-4BannersPlusSlide.vue')
)
r('dpc-Accordion', () =>
	import(/* webpackChunkName: "dpc" */ '@/v-shop/dynamic-pages-components/comp_dpc-Accordion.vue')
)
r('dpc-AccordionV2', () =>
	import(/* webpackChunkName: "dpc" */ '@/v-shop/dynamic-pages-components/comp_dpc-AccordionV2.vue')
)
r('dpc-Banner1', () => import(/* webpackChunkName: "dpc" */ '@/v-shop/dynamic-pages-components/comp_dpc-Banner1.vue'))
r('dpc-Banner2', () => import(/* webpackChunkName: "dpc" */ '@/v-shop/dynamic-pages-components/comp_dpc-Banner2.vue'))
r('dpc-Banner3', () => import(/* webpackChunkName: "dpc" */ '@/v-shop/dynamic-pages-components/comp_dpc-Banner3.vue'))
r('dpc-Banner4', () => import(/* webpackChunkName: "dpc" */ '@/v-shop/dynamic-pages-components/comp_dpc-Banner4.vue'))
r('dpc-Banner5', () => import(/* webpackChunkName: "dpc" */ '@/v-shop/dynamic-pages-components/comp_dpc-Banner5.vue'))
r('dpc-Banner6', () => import(/* webpackChunkName: "dpc" */ '@/v-shop/dynamic-pages-components/comp_dpc-Banner6.vue'))
r('dpc-BannerUnified', () =>
	import(/* webpackChunkName: "dpc" */ '@/v-shop/dynamic-pages-components/comp_dpc-BannerUnified.vue')
)
r('dpc-BrandsBoard', () =>
	import(/* webpackChunkName: "dpc" */ '@/v-shop/dynamic-pages-components/comp_dpc-BrandsBoard.vue')
)
r('dpc-CarouselMultiple', () =>
	import(/* webpackChunkName: "dpc" */ '@/v-shop/dynamic-pages-components/comp_dpc-CarouselMultiple.vue')
)
r('dpc-CarouselMultiplePro', () =>
	import(/* webpackChunkName: "dpc" */ '@/v-shop/dynamic-pages-components/comp_dpc-CarouselMultiplePro.vue')
)
r('dpc-DynamicBanner', () =>
	import(/* webpackChunkName: "dpc" */ '@/v-shop/dynamic-pages-components/comp_dpc-DynamicBanner.vue')
)
r('dpc-DynamicDpc', () =>
	import(/* webpackChunkName: "dpc" */ '@/v-shop/dynamic-pages-components/comp_dpc-DynamicDpc.vue')
)
r('dpc-EnhancedProductsCarousel', () =>
	import(/* webpackChunkName: "dpc" */ '@/v-shop/dynamic-pages-components/comp_dpc-EnhancedProductsCarousel.vue')
)
r('dpc-GoogleReviews', () =>
	import(/* webpackChunkName: "dpc" */ '@/v-shop/dynamic-pages-components/comp_dpc-GoogleReviews.vue')
)
r('dpc-Hotspot', () => import(/* webpackChunkName: "dpc" */ '@/v-shop/dynamic-pages-components/comp_dpc-Hotspot.vue'))
r('dpc-HtmlInsert', () =>
	import(/* webpackChunkName: "dpc" */ '@/v-shop/dynamic-pages-components/comp_dpc-HtmlInsert.vue')
)
r('dpc-ImagesCarousel', () =>
	import(/* webpackChunkName: "dpc" */ '@/v-shop/dynamic-pages-components/comp_dpc-ImagesCarousel.vue')
)
r('dpc-ImagesSlider', () =>
	import(/* webpackChunkName: "dpc" */ '@/v-shop/dynamic-pages-components/comp_dpc-ImagesSlider.vue')
)
r('dpc-ImagesSliderV2', () =>
	import(/* webpackChunkName: "dpc" */ '@/v-shop/dynamic-pages-components/comp_dpc-ImagesSliderV2.vue')
)
r('dpc-ImageTextCta', () =>
	import(/* webpackChunkName: "dpc" */ '@/v-shop/dynamic-pages-components/comp_dpc-ImageTextCta.vue')
)
r('dpc-ListCardWithIcon', () =>
	import(/* webpackChunkName: "dpc" */ '@/v-shop/dynamic-pages-components/comp_dpc-ListCardWithIcon.vue')
)
r('dpc-Newsletter', () =>
	import(/* webpackChunkName: "dpc" */ '@/v-shop/dynamic-pages-components/comp_dpc-Newsletter.vue')
)
r('dpc-OffersBoard', () =>
	import(/* webpackChunkName: "dpc" */ '@/v-shop/dynamic-pages-components/comp_dpc-OffersBoard.vue')
)
r('dpc-OffersPlusBanners', () =>
	import(/* webpackChunkName: "dpc" */ '@/v-shop/dynamic-pages-components/comp_dpc-OffersPlusBanners.vue')
)
r('dpc-ProductsBoard', () =>
	import(/* webpackChunkName: "dpc" */ '@/v-shop/dynamic-pages-components/comp_dpc-ProductsBoard.vue')
)
r('dpc-ProductsBoardWithData', () =>
	import(/* webpackChunkName: "dpc" */ '@/v-shop/dynamic-pages-components/comp_dpc-ProductsBoardWithData.vue')
)
r('dpc-ProductsCarouselUnified', () =>
	import(/* webpackChunkName: "dpc" */ '@/v-shop/dynamic-pages-components/comp_dpc-ProductsCarouselUnified.vue')
)
r('dpc-ProductsListWithFilters', () =>
	import(/* webpackChunkName: "dpc" */ '@/v-shop/dynamic-pages-components/comp_dpc-ProductsListWithFilters.vue')
)
r('dpc-Richtext', () => import(/* webpackChunkName: "dpc" */ '@/v-shop/dynamic-pages-components/comp_dpc-Richtext.vue'))
r('dpc-SliderPlus2Banners', () =>
	import(/* webpackChunkName: "dpc" */ '@/v-shop/dynamic-pages-components/comp_dpc-SliderPlus2Banners.vue')
)
r('dpc-SliderPlusFeatured', () =>
	import(/* webpackChunkName: "dpc" */ '@/v-shop/dynamic-pages-components/comp_dpc-SliderPlusFeatured.vue')
)
r('dpc-Spacer', () => import(/* webpackChunkName: "dpc" */ '@/v-shop/dynamic-pages-components/comp_dpc-Spacer.vue'))
r('dpc-VideoBackground', () =>
	import(/* webpackChunkName: "dpc" */ '@/v-shop/dynamic-pages-components/comp_dpc-VideoBackground.vue')
)
r('dpc-WordpressPosts', () =>
	import(/* webpackChunkName: "dpc" */ '@/v-shop/dynamic-pages-components/comp_dpc-WordpressPosts.vue')
)
r('DynamicPageItems', () =>
	import(/* webpackChunkName: "dpc" */ '@/v-shop/dynamic-pages-components/comp_DynamicPageItems.vue')
)
r('HotspotItem', () => import(/* webpackChunkName: "dpc" */ '@/v-shop/dynamic-pages-components/comp_HotspotItem.vue'))
r('RecursiveHtmlJson', () =>
	import(/* webpackChunkName: "dpc" */ '@/v-shop/dynamic-pages-components/comp_RecursiveHtmlJson.vue')
)
r('WordpressPostItem', () =>
	import(/* webpackChunkName: "dpc" */ '@/v-shop/dynamic-pages-components/comp_WordpressPostItem.vue')
)
r('WordpressPostItemHorizontal', () =>
	import(/* webpackChunkName: "dpc" */ '@/v-shop/dynamic-pages-components/comp_WordpressPostItemHorizontal.vue')
)
r('DeliveryOptionContent-PickupPoint', () =>
	import(/* webpackChunkName: "order" */ '@/v-shop/order/comp_DeliveryOptionContent-PickupPoint.vue')
)
r('DeliveryOptionContent-Shipping', () =>
	import(/* webpackChunkName: "order" */ '@/v-shop/order/comp_DeliveryOptionContent-Shipping.vue')
)
r('DeliveryOptionContent', () =>
	import(/* webpackChunkName: "order" */ '@/v-shop/order/comp_DeliveryOptionContent.vue')
)
r('OrderSummary-Item', () => import(/* webpackChunkName: "order" */ '@/v-shop/order/comp_OrderSummary-Item.vue'))
r('OrderSummary-Totals', () => import(/* webpackChunkName: "order" */ '@/v-shop/order/comp_OrderSummary-Totals.vue'))
r('OrderSummary', () => import(/* webpackChunkName: "order" */ '@/v-shop/order/comp_OrderSummary.vue'))
r('AddressDialog', () => import(/* webpackChunkName: "checkout" */ '@/v-shop/checkout/common/comp_AddressDialog.vue'))
r('CheckoutCollapsedSummary', () =>
	import(/* webpackChunkName: "checkout" */ '@/v-shop/checkout/common/comp_CheckoutCollapsedSummary.vue')
)
r('CheckoutPaymentCardContent', () =>
	import(/* webpackChunkName: "checkout" */ '@/v-shop/checkout/common/comp_CheckoutPaymentCardContent.vue')
)
r('CheckoutStepBox', () =>
	import(/* webpackChunkName: "checkout" */ '@/v-shop/checkout/common/comp_CheckoutStepBox.vue')
)
r('CheckoutSummary', () =>
	import(/* webpackChunkName: "checkout" */ '@/v-shop/checkout/common/comp_CheckoutSummary.vue')
)
r('CheckoutSummaryCouponForm', () =>
	import(/* webpackChunkName: "checkout" */ '@/v-shop/checkout/common/comp_CheckoutSummaryCouponForm.vue')
)
r('CountrySelector', () =>
	import(/* webpackChunkName: "checkout" */ '@/v-shop/checkout/common/comp_CountrySelector.vue')
)
r('IndeterminateProgressBtn', () =>
	import(/* webpackChunkName: "checkout" */ '@/v-shop/checkout/common/comp_IndeterminateProgressBtn.vue')
)
r('MaskedTextField', () =>
	import(/* webpackChunkName: "checkout" */ '@/v-shop/checkout/common/comp_MaskedTextField.vue')
)
r('CheckoutApp', () => import(/* webpackChunkName: "checkout" */ '@/v-shop/checkout/comp_CheckoutApp.vue'))
r('CheckoutStep-confirm--active', () =>
	import(/* webpackChunkName: "checkout" */ '@/v-shop/checkout/step-confirm/comp_CheckoutStep-confirm--active.vue')
)
r('CheckoutStep-confirm--done', () =>
	import(/* webpackChunkName: "checkout" */ '@/v-shop/checkout/step-confirm/comp_CheckoutStep-confirm--done.vue')
)
r('CheckoutStep-confirm-Void--active', () =>
	import(
		/* webpackChunkName: "checkout" */ '@/v-shop/checkout/step-confirm/comp_CheckoutStep-confirm-Void--active.vue'
	)
)
r('CheckoutStep-contact--active', () =>
	import(/* webpackChunkName: "checkout" */ '@/v-shop/checkout/step-contact/comp_CheckoutStep-contact--active.vue')
)
r('CheckoutStep-contact--done', () =>
	import(/* webpackChunkName: "checkout" */ '@/v-shop/checkout/step-contact/comp_CheckoutStep-contact--done.vue')
)
r('CheckoutDeliveryOptionItem', () =>
	import(/* webpackChunkName: "checkout" */ '@/v-shop/checkout/step-delivery/comp_CheckoutDeliveryOptionItem.vue')
)
r('CheckoutDeliveryPickupPointsSelectorDialog', () =>
	import(
		/* webpackChunkName: "checkout" */ '@/v-shop/checkout/step-delivery/comp_CheckoutDeliveryPickupPointsSelectorDialog.vue'
	)
)
r('CheckoutDeliverySellerBox', () =>
	import(/* webpackChunkName: "checkout" */ '@/v-shop/checkout/step-delivery/comp_CheckoutDeliverySellerBox.vue')
)
r('CheckoutDeliverySellerOrderItemsBox', () =>
	import(
		/* webpackChunkName: "checkout" */ '@/v-shop/checkout/step-delivery/comp_CheckoutDeliverySellerOrderItemsBox.vue'
	)
)
r('CheckoutStep-delivery--active', () =>
	import(/* webpackChunkName: "checkout" */ '@/v-shop/checkout/step-delivery/comp_CheckoutStep-delivery--active.vue')
)
r('CheckoutStep-delivery--done', () =>
	import(/* webpackChunkName: "checkout" */ '@/v-shop/checkout/step-delivery/comp_CheckoutStep-delivery--done.vue')
)
r('CheckoutDiscountForm-couponCode', () =>
	import(/* webpackChunkName: "checkout" */ '@/v-shop/checkout/step-discount/comp_CheckoutDiscountForm-couponCode.vue')
)
r('CheckoutDiscountForm-giftCardCode', () =>
	import(
		/* webpackChunkName: "checkout" */ '@/v-shop/checkout/step-discount/comp_CheckoutDiscountForm-giftCardCode.vue'
	)
)
r('CheckoutStep-discount--active', () =>
	import(/* webpackChunkName: "checkout" */ '@/v-shop/checkout/step-discount/comp_CheckoutStep-discount--active.vue')
)
r('CheckoutStep-discount--done', () =>
	import(/* webpackChunkName: "checkout" */ '@/v-shop/checkout/step-discount/comp_CheckoutStep-discount--done.vue')
)
r('CheckoutStep-payment--active', () =>
	import(/* webpackChunkName: "checkout" */ '@/v-shop/checkout/step-payment/comp_CheckoutStep-payment--active.vue')
)
r('CheckoutStep-payment--done', () =>
	import(/* webpackChunkName: "checkout" */ '@/v-shop/checkout/step-payment/comp_CheckoutStep-payment--done.vue')
)
r('CheckoutStep-signin--active', () =>
	import(/* webpackChunkName: "checkout" */ '@/v-shop/checkout/step-signin/comp_CheckoutStep-signin--active.vue')
)
r('CheckoutStep-signin--done', () =>
	import(/* webpackChunkName: "checkout" */ '@/v-shop/checkout/step-signin/comp_CheckoutStep-signin--done.vue')
)
r('Autocomplete', () => import(/* webpackChunkName: "checkout" */ '@/vuetify-common/comp_Autocomplete.vue'))
r('DatePickerDialog', () => import(/* webpackChunkName: "checkout" */ '@/vuetify-common/comp_DatePickerDialog.vue'))
r('MagicButton', () => import(/* webpackChunkName: "checkout" */ '@/vuetify-common/comp_MagicButton.vue'))
r('Select', () => import(/* webpackChunkName: "checkout" */ '@/vuetify-common/comp_Select.vue'))
r('TextArea', () => import(/* webpackChunkName: "checkout" */ '@/vuetify-common/comp_TextArea.vue'))
r('ValidationMessage', () => import(/* webpackChunkName: "checkout" */ '@/vuetify-common/comp_ValidationMessage.vue'))
r('DefaultProducts', () =>
	import(/* webpackChunkName: "shoplist" */ '@/v-shop/shop-list-view/comp_DefaultProducts.vue')
)
r('DescriptionExpandable', () =>
	import(/* webpackChunkName: "shoplist" */ '@/v-shop/shop-list-view/comp_DescriptionExpandable.vue')
)
r('ShopFilters', () => import(/* webpackChunkName: "shoplist" */ '@/v-shop/shop-list-view/comp_ShopFilters.vue'))
r('ShopFiltersGroup', () =>
	import(/* webpackChunkName: "shoplist" */ '@/v-shop/shop-list-view/comp_ShopFiltersGroup.vue')
)
r('ShopFiltersRemovalChips', () =>
	import(/* webpackChunkName: "shoplist" */ '@/v-shop/shop-list-view/comp_ShopFiltersRemovalChips.vue')
)
r('ShopSortSelect', () => import(/* webpackChunkName: "shoplist" */ '@/v-shop/shop-list-view/comp_ShopSortSelect.vue'))
r('UpsellProductCard', () =>
	import(/* webpackChunkName: "product" */ '@/v-shop/product-upsells-view/comp_UpsellProductCard.vue')
)
r('UserpanelLayout', () => import(/* webpackChunkName: "account" */ '@/v-shop/account/comp_UserpanelLayout.vue'))
r('UserOrderDetail-Contact', () =>
	import(/* webpackChunkName: "account" */ '@/v-shop/account/order-details/comp_UserOrderDetail-Contact.vue')
)
r('UserOrderDetail-Delivery', () =>
	import(/* webpackChunkName: "account" */ '@/v-shop/account/order-details/comp_UserOrderDetail-Delivery.vue')
)
r('UserOrderDetail-DigitalItems', () =>
	import(/* webpackChunkName: "account" */ '@/v-shop/account/order-details/comp_UserOrderDetail-DigitalItems.vue')
)
r('UserOrderDetail-Discount', () =>
	import(/* webpackChunkName: "account" */ '@/v-shop/account/order-details/comp_UserOrderDetail-Discount.vue')
)
r('UserOrderDetail-Payment', () =>
	import(/* webpackChunkName: "account" */ '@/v-shop/account/order-details/comp_UserOrderDetail-Payment.vue')
)
r('UserOrderDetail-PaymentInstructions', () =>
	import(
		/* webpackChunkName: "account" */ '@/v-shop/account/order-details/comp_UserOrderDetail-PaymentInstructions.vue'
	)
)
r('ChangePassword', () =>
	import(/* webpackChunkName: "account" */ '@/v-shop/account/user-account/comp_ChangePassword.vue')
)
r('ContactData', () => import(/* webpackChunkName: "account" */ '@/v-shop/account/user-account/comp_ContactData.vue'))
r('ReviewCard', () => import(/* webpackChunkName: "account" */ '@/v-shop/account/user-account/comp_ReviewCard.vue'))
r('UserData', () => import(/* webpackChunkName: "account" */ '@/v-shop/account/user-account/comp_UserData.vue'))
r('UserReviewDialog', () =>
	import(/* webpackChunkName: "account" */ '@/v-shop/account/user-account/comp_UserReviewDialog.vue')
)
r('NotFoundPage', () => import(/* webpackChunkName: "notfoundpage" */ '@/v-shop/not-found-page/comp_NotFoundPage.vue'))
r('SmartPopup-Form', () => import(/* webpackChunkName: "smartpopup" */ '@/v-shop/smart-popup/comp_SmartPopup-Form.vue'))
r('SmartPopupBottom', () =>
	import(/* webpackChunkName: "smartpopup" */ '@/v-shop/smart-popup/comp_SmartPopupBottom.vue')
)
r('SmartPopupCenter', () =>
	import(/* webpackChunkName: "smartpopup" */ '@/v-shop/smart-popup/comp_SmartPopupCenter.vue')
)
r('SmartPopupRight', () => import(/* webpackChunkName: "smartpopup" */ '@/v-shop/smart-popup/comp_SmartPopupRight.vue'))
r('OfferCard', () => import(/* webpackChunkName: "offerdrawer" */ '@/v-shop/offer-drawer/comp_OfferCard.vue'))
r('OfferDrawer', () => import(/* webpackChunkName: "offerdrawer" */ '@/v-shop/offer-drawer/comp_OfferDrawer.vue'))
r('OfferDrawerButton', () =>
	import(/* webpackChunkName: "offerdrawer" */ '@/v-shop/offer-drawer/comp_OfferDrawerButton.vue')
)
r('OfferItem', () => import(/* webpackChunkName: "offerdrawer" */ '@/v-shop/offer-drawer/comp_OfferItem.vue'))
r('UserOrderDetail-PaymentInstructions-Modo', () =>
	import(/* webpackChunkName: "account" */ '@/v-shop/account/comp_UserOrderDetail-PaymentInstructions-Modo.vue')
)
r('CheckoutStep-confirm-Modo--active', () =>
	import(/* webpackChunkName: "checkout" */ '@/v-shop/checkout/comp_CheckoutStep-confirm-Modo--active.vue')
)
r('CreditCard-OperatorFormInputs-MercadoPago', () =>
	import(/* webpackChunkName: "credit-card" */ '@/v-shop/comp_CreditCard-OperatorFormInputs-MercadoPago.vue')
)
r('CreditCard-OperatorResolver-MercadoPago', () =>
	import(/* webpackChunkName: "credit-card" */ '@/v-shop/comp_CreditCard-OperatorResolver-MercadoPago.vue')
)
r('CreditCard-OperatorResolver-Decidir', () =>
	import(/* webpackChunkName: "credit-card" */ '@/v-shop/comp_CreditCard-OperatorResolver-Decidir.vue')
)
r('UserOrderDetail-Payment-CreditCard', () =>
	import(/* webpackChunkName: "account" */ '@/v-shop/account/comp_UserOrderDetail-Payment-CreditCard.vue')
)
r('CreditCardPlanSelector', () =>
	import(/* webpackChunkName: "credit-card" */ '@/v-shop/credit-card/comp_CreditCardPlanSelector.vue')
)
r('CheckoutStep-confirm-CreditCard--active', () =>
	import(/* webpackChunkName: "checkout" */ '@/v-shop/checkout/comp_CheckoutStep-confirm-CreditCard--active.vue')
)
r('CheckoutStep-payment-CreditCard--active', () =>
	import(/* webpackChunkName: "checkout" */ '@/v-shop/checkout/comp_CheckoutStep-payment-CreditCard--active.vue')
)
r('CheckoutStep-payment-CreditCard--done', () =>
	import(/* webpackChunkName: "checkout" */ '@/v-shop/checkout/comp_CheckoutStep-payment-CreditCard--done.vue')
)
r('CreditCardFormInputs', () =>
	import(/* webpackChunkName: "checkout" */ '@/v-shop/checkout/comp_CreditCardFormInputs.vue')
)
r('CreditCardPlanBox', () => import(/* webpackChunkName: "checkout" */ '@/v-shop/checkout/comp_CreditCardPlanBox.vue'))
r('PaymentsModal-CreditCard-Select', () =>
	import(/* webpackChunkName: "product" */ '@/v-shop/product/comp_PaymentsModal-CreditCard-Select.vue')
)
r('ProductPage-PaymentsModal-CreditCard', () =>
	import(/* webpackChunkName: "product" */ '@/v-shop/product/comp_ProductPage-PaymentsModal-CreditCard.vue')
)
r('UserOrderDetail-PaymentInstructions-Mobbex', () =>
	import(/* webpackChunkName: "account" */ '@/v-shop/account/comp_UserOrderDetail-PaymentInstructions-Mobbex.vue')
)
r('CheckoutStep-confirm-Mobbex--active', () =>
	import(/* webpackChunkName: "checkout" */ '@/v-shop/checkout/comp_CheckoutStep-confirm-Mobbex--active.vue')
)
r('UserOrderDetail-PaymentInstructions-GoCuotas', () =>
	import(/* webpackChunkName: "account" */ '@/v-shop/account/comp_UserOrderDetail-PaymentInstructions-GoCuotas.vue')
)
r('CheckoutStep-confirm-GoCuotas--active', () =>
	import(/* webpackChunkName: "checkout" */ '@/v-shop/checkout/comp_CheckoutStep-confirm-GoCuotas--active.vue')
)
r('CheckoutStep-confirm-Cash--active', () =>
	import(/* webpackChunkName: "checkout" */ '@/v-shop/checkout/comp_CheckoutStep-confirm-Cash--active.vue')
)
r('UserOrderDetail-PaymentInstructions-WireTransfer', () =>
	import(
		/* webpackChunkName: "account" */ '@/v-shop/account/comp_UserOrderDetail-PaymentInstructions-WireTransfer.vue'
	)
)
r('CheckoutStep-confirm-WireTransfer--active', () =>
	import(/* webpackChunkName: "checkout" */ '@/v-shop/checkout/comp_CheckoutStep-confirm-WireTransfer--active.vue')
)
r('UserOrderDetail-PaymentInstructions-MercadoPago', () =>
	import(/* webpackChunkName: "account" */ '@/v-shop/account/comp_UserOrderDetail-PaymentInstructions-MercadoPago.vue')
)
r('CheckoutStep-confirm-MercadoPago--active', () =>
	import(/* webpackChunkName: "checkout" */ '@/v-shop/checkout/comp_CheckoutStep-confirm-MercadoPago--active.vue')
)

export const views = {
	Home: require('@/v-shop/view_Home.vue').default,
	ProductPage: () => import(/* webpackChunkName: "productpage" */ '@/v-shop/product/view_ProductPage.vue'),
	DynamicPage: () => import(/* webpackChunkName: "dpc" */ '@/v-shop/dynamic-pages-components/view_DynamicPage.vue'),
	Checkout: () => import(/* webpackChunkName: "checkout" */ '@/v-shop/checkout/view_Checkout.vue'),
	ShopList: () => import(/* webpackChunkName: "shoplist" */ '@/v-shop/shop-list-view/view_ShopList.vue'),
	ProductUpsells: () =>
		import(/* webpackChunkName: "product" */ '@/v-shop/product-upsells-view/view_ProductUpsells.vue'),
	UserFavorites: () => import(/* webpackChunkName: "account" */ '@/v-shop/account/favorites/view_UserFavorites.vue'),
	UserOrderDetail: () =>
		import(/* webpackChunkName: "account" */ '@/v-shop/account/order-details/view_UserOrderDetail.vue'),
	UserOrders: () => import(/* webpackChunkName: "account" */ '@/v-shop/account/order-details/view_UserOrders.vue'),
	UserAccount: () => import(/* webpackChunkName: "account" */ '@/v-shop/account/user-account/view_UserAccount.vue'),
	UserReviews: () => import(/* webpackChunkName: "account" */ '@/v-shop/account/user-account/view_UserReviews.vue'),
	RepentanceForm: () => import(/* webpackChunkName: "repentance" */ '@/v-shop/repentance/view_RepentanceForm.vue'),
}

/* Routes */
export const routesProviders = [
	require('./routes/routes_account.js').default,
	require('./routes/routes_catalog.js').default,
	require('./routes/routes_checkout.js').default,
	require('./routes/routes_dynamicPages.js').default,
	require('../../../v-shop-dynamic-home/vue-src/v-shop/routes_home.js').default,
]

/* Stores */
export const storesProviders = [require('./stores/store_cart.js').default, require('./stores/store_shop.js').default]

/* Plugins */
export const pluginsRunners = [
	require('../../../admin/vue-src/media/plugin_media.js').default,
	require('../../../site-analytics/vue-src/analytics/plugin_analytics.js').default,
	require('../../../cc-clearsale/vue-src/v-shop/plugin_clearsale.js').default,
	require('./plugins/plugin_app-component.js').default,
	require('./plugins/plugin_base-css-vars.js').default,
	require('./plugins/plugin_cart-auto-removals.js').default,
	require('./plugins/plugin_filters.js').default,
	require('./plugins/plugin_lang.js').default,
	require('./plugins/plugin_shop-analytics.js').default,
	require('./plugins/plugin_shop-api.js').default,
	require('./plugins/plugin_shop.js').default,
	require('./plugins/plugin_super-sticky.js').default,
	require('./plugins/plugin_user-wishlist.js').default,
	require('./plugins/plugin_vuetify.js').default,
]

/* Styles */
require('./styles/styles___reset.scss')
require('./styles/styles__base.scss')
require('./styles/styles__fonts.scss')
require('./styles/styles__mdi-icons.scss')
require('./styles/styles_ssr-carousel.scss')
require('./styles/styles_v-checkbox.scss')
